<template>
  <article>
    <h3 class="h3-titles title-underline">
      {{ $t("profiles.titles.reserveAccommodation") }}
    </h3>
    <div class="titles">
      <button class="reserve-button" @click="redirectToReservation">
        {{ $t("wegow.events.accommodation.reserve") }}
      </button>
    </div>
    <Suspense>
      <template #default>
        <accommodation
          :address="address"
          :iso-code="isoCode"
          :location="location"
          :start-date="startDate"
          class="accomodation-class"
        />
      </template>
      <template #fallback>
        <wegow-loader class="min-h-screen" />
      </template>
    </Suspense>
  </article>
</template>

<script setup>
import Accommodation from "@/components/general/ui/elements/AccommodationComponent.vue";

const props = defineProps({
  address: {
    type: String,
    default: ""
  },
  isoCode: {
    type: String,
    default: "ES"
  },
  location: {
    type: Object,
    default: () => ({})
  },
  startDate: {
    type: String,
    default: ""
  }
});

const redirectToReservation = () => {
  if (props.address) {
    const reservationUrl = `https://stay22.com/allez/roam?aid=wegow&campaign=button&address=${encodeURIComponent(
      props.address
    )}`;
    window.open(reservationUrl, "_blank");
  } else {
    console.error("Event address not available");
  }
};
</script>

<style lang="scss" scoped>
@import "@/components/general/ui/profiles/profiles.scss";
.reserve-button {
  background-color: #2effec;
  color: black;
  border-radius: 50px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  margin-right: 10px; /* Espacio entre el botón y un posible título */
  padding: 10px 30px;
  text-align: right; /* Alinear el texto a la derecha */
  float: right; /* Alinear el botón a la derecha */
  margin-bottom: 3%;
  max-width: 100%; /* Asegura que el botón no exceda el ancho del contenedor */
}
.titles {
  margin-left: auto;
  margin-top: -4.5%;
  margin-bottom: 30px;
  text-align: right; /* Alinear el contenedor a la derecha */
  max-width: 90%; /* Limita el ancho del contenedor */
}

.accomodation-class {
  padding: 20px 30px; /* Agrega un poco de relleno interno */
  max-width: 1200px; /* Limita el ancho máximo */
  margin: 0 auto; /* Centra el contenido horizontalmente */
}

/* Media queries para mejorar la responsividad */
@media (max-width: 768px) {
  * {
    padding-left: 10px;
    padding-right: 10px;
  }
  .reserve-button {
    font-size: 14px;
    margin-top: -15%;
    padding: 3px 20px;
  }

  .titles {
    margin-top: 0;
    text-align: center; /* Centra el texto en pantallas pequeñas */
  }

  .accomodation-class {
    padding: 0px 0px; /* Reduce el padding en pantallas pequeñas */
  }
}

@media (max-width: 480px) {
  .reserve-button {
    font-size: 12px;
  }

  .accomodation-class {
    padding: 0px 0px; /* Ajusta aún más el padding para pantallas muy pequeñas */
  }
}
</style>
